import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from "react-accessible-accordion";

const FAQPageAccordionForFamilies = () => {

  return (
    <Accordion preExpanded={[1]} key="becomeAHostPageFAQ" allowZeroExpanded >
      <AccordionItem uuid={1}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Can families buy seats in AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Yes, absolutely. But if you want the course to count for credit in your child’s school, you should
            get explicit confirmation in advance from the school that they will accept the course for credit.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={2}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Can families pay for courses for our kids if their schools won’t?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Yes, and this may be something you work out directly with the school administration,
            whereby you pay for a course but the school still gives it credit.
          </p>
          <p>
            Example: You’re a parent, and your child wants to take an Italian language course through AllCourse.
            Your child’s school only offers French and Spanish. You ask the principal if they will pay for a seat
            in the online Italian language course, but the principal declines, saying that they don’t have any extra
            budget for languages. However, if you’re willing to pay out-of-pocket for the course, you can ask that the
            school accept the credit for the online Italian course in lieu of an on-ground language course taught in the school.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={3}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Is AllCourse good for home-schoolers?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Yes. AllCourse provides a huge selection of subjects, class sizes, and teaching styles.
            And because the courses are taught by licensed teachers and offered in schools for-credit, schools and
            colleges immediately understand what these courses are about when they see them on your child’s record.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={4}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Why would our family want to use AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Families looking for courses that their schools don’t offer can usually find them listed on AllCourse.
            That might be AP courses. Or coding, robotics, or AI. It could be courses that are seldom taught now,
            like civics or home economics. It could be any foreign language on earth. Or different kinds of special
            education courses. Or any kind of elective you can imagine. Chances are it’s being taught on AllCourse.
          </p>
          <p>
            Home-schoolers may want to use AllCourse both to supplement their curricula and also to increase the transferability
            and transparency of what their children are learning.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={5}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How do I take a course?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            After you have found a teacher and paid for the course, your teacher will send you
            details to participate in the online class.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={6}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What is your refund policy?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            School admins can cancel seats and receive a refund, depending on when they cancel. For most courses, you can
            cancel and request a refund anytime during the first week of classes. This allows everyone involved to make sure
            that the fit is right between the student and the class. However, some courses are very short, such as custom
            courses that teachers offer to a particular school to solve a short-term staffing crisis. If a course is less
            than 3 weeks long, you can cancel and request a refund anytime prior to the first class session.
          </p>
          <p>
            In the event that a teacher wishes to cancel a course listing, they may do so under the following conditions:
          </p>
          <ul>
            <li>the minimum number of seats have not yet been met; and</li>
            <li>the course start date has not passed</li>
          </ul>
          <p>
            This allows for teachers to cancel courses that do not meet their profitability threshold, but protects school
            administrators so that they can rely on seats they pay for being fulfilled. If a teacher cancels a course,
            100% of the cost of the seats will be refunded to all purchasers.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default FAQPageAccordionForFamilies;
